import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  padding: 0;
  max-width: 1000px;
  width: 95%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  display: flex;
  flex-direction: column;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 2px solid #e1e8ed;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 20%);
`;

export const ModalTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  color: #657786;
  transition: all 0.2s ease;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  line-height: 1;

  &:hover {
    background: rgba(0, 123, 255, 0.1);
    color: #007bff;
    transform: rotate(90deg);
  }
`;

export const ModalBody = styled.div`
  padding: 32px;
  overflow-y: auto;
  flex: 1;
`;

export const FormSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    width: 4px;
    height: 20px;
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    border-radius: 2px;
  }
`;

export const FormRow = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: ${props => props.columns === 1 ? '1fr' : props.columns === 3 ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'};
  gap: 16px;
  margin-bottom: 16px;
`;

export const FormGroup = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Required = styled.span`
  color: #f5576c;
`;

export const Input = styled.input`
  padding: 12px 16px;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }

  &::placeholder {
    color: #aab8c2;
  }
`;

export const TextArea = styled.textarea`
  padding: 12px 16px;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }

  &::placeholder {
    color: #aab8c2;
  }
`;

export const Select = styled.select`
  padding: 12px 16px;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 2px solid #e1e8ed;
  padding-bottom: 2px;
`;

export const Tab = styled.button<{ active?: boolean }>`
  padding: 12px 24px;
  border: none;
  background: ${props => props.active ? 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)' : 'transparent'};
  color: ${props => props.active ? 'white' : '#657786'};
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: ${props => props.active ? 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)' : 'rgba(0, 123, 255, 0.1)'};
    color: ${props => props.active ? 'white' : '#007bff'};
  }

  ${props => props.active && `
    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    }
  `}
`;

export const QuestionSelectionCard = styled.div`
  border: 2px solid #e1e8ed;
  border-radius: 12px;
  padding: 20px;
  background: #f5f7fa;
`;

export const InfoText = styled.p`
  color: #657786;
  font-size: 13px;
  margin: 0;
  line-height: 1.6;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 32px;
  border-top: 2px solid #e1e8ed;
  background: #f5f7fa;
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 12px 28px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props => props.variant === 'primary' 
    ? 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)' 
    : '#e1e8ed'
  };
  color: ${props => props.variant === 'primary' ? 'white' : '#2c3e50'};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.variant === 'primary' 
      ? '0 6px 20px rgba(0, 123, 255, 0.4)' 
      : '0 4px 12px rgba(0, 0, 0, 0.1)'
    };
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const QuestionListContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  padding: 12px;
  background: white;
`;

export const QuestionItem = styled.div<{ selected?: boolean }>`
  padding: 12px;
  border: 2px solid ${props => props.selected ? '#007bff' : '#e1e8ed'};
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props => props.selected ? 'rgba(0, 123, 255, 0.05)' : 'white'};

  &:hover {
    border-color: #007bff;
    background: rgba(0, 123, 255, 0.05);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const QuestionItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const QuestionItemTitle = styled.span`
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
`;

export const QuestionItemBadge = styled.span<{ type?: string }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: ${props => {
    switch(props.type) {
      case 'easy': return '#d4edda';
      case 'medium': return '#fff3cd';
      case 'hard': return '#f8d7da';
      default: return '#e1e8ed';
    }
  }};
  color: ${props => {
    switch(props.type) {
      case 'easy': return '#155724';
      case 'medium': return '#856404';
      case 'hard': return '#721c24';
      default: return '#2c3e50';
    }
  }};
`;

export const QuestionItemContent = styled.div`
  font-size: 13px;
  color: #657786;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const SelectedCount = styled.div`
  padding: 12px;
  background: linear-gradient(135deg, rgba(0, 123, 255, 0.1) 0%, rgba(0, 86, 179, 0.1) 100%);
  border-radius: 10px;
  text-align: center;
  font-weight: 600;
  color: #007bff;
  margin-top: 12px;
`;
